import Modal, { ModalWidthEnum } from 'components/Modal';
import { useDeleteImpersonationMutation, useImpersonateUserMutation } from 'redux/apiSlices/user.slice';
import { RoutesNames } from 'routes/RoutesNames';
import { useHistory } from 'react-router-dom';
import { Text } from 'components/Typography';
import toast from 'components/Notification';

const ImpersonationConfirmationModal = ({
  open,
  onCancel,
  usersData,
  path,
}: {
  open: boolean;
  onCancel: () => void;
  usersData: any;
  path: any;
}) => {
  const { impersonateOn } = usersData || {};

  const history = useHistory();

  const search = path?.search ? new URLSearchParams(path.search) : null;
  const [impersonateUserData] = useImpersonateUserMutation();
  const [deleteImpersonation] = useDeleteImpersonationMutation();
  const impersonateForRedirection = async () => {
    if (search === null || path?.pathname === null) {
      return;
    }
    if (impersonateOn) {
      try {
        await deleteImpersonation().unwrap();
      } catch (e) {
        toast({
          type: 'error',
          description: 'Something went wrong!',
        });
      }
    }
    const searchParams = new URLSearchParams(path.search);

    const landlordId = searchParams.get('propertyManagementId');
    const objectId = searchParams.get('objectId');

    try {
      // @ts-ignore
      await impersonateUserData(landlordId).unwrap();
      history.push(
        `${path.pathname === RoutesNames.RedirectComplaint ? RoutesNames.Complaint : RoutesNames.Notice}/${objectId}`
      );
      onCancel();
    } catch (e) {
      toast({
        type: 'error',
        description: 'Something went wrong!',
      });
    }
  };
  return (
    <Modal
      centered
      title='Confirm impersonation'
      size={ModalWidthEnum.Medium}
      visible={open}
      okText='Impersonate'
      onOk={impersonateForRedirection}
      onCancel={onCancel}
      confirmLoading={false}
      destroyOnClose
    >
      <Text>You need to impersonate {search?.get('propertyManagementName')} first.</Text>
    </Modal>
  );
};

export default ImpersonationConfirmationModal;
